// extracted by mini-css-extract-plugin
export default {"login":"Login_login__dBZAW","loginFormHeader":"Login_loginFormHeader__i86+v","loginFormBody":"Login_loginFormBody__FjqaF"};